import {CallEntity} from "./call-entity";

export interface CallUpdate {

    id: string;

    state: CallUpdateState;

    installation_id: string;

    caller: CallEntity;

}

export enum CallUpdateState {
    Started = 'started',
    Rejected = 'rejected',
    Forwarded = 'forwarded',
    Canceled = 'canceled',
    Bridged = 'bridged',
    Missed = 'missed',
    Answered = 'answered'
}
